/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CluUtteranceSwagger } from 'src/clu/core/services/cluUtteranceSwagger';
import { FiltersItem } from 'src/verticals/utterancesFilters/types/Filters';

/**
 * Checks if the utterance has one of the labeled entities match with any entity that we filter on.
 *
 * @param appliedEntityFilters The entities filters to be applied.
 * @param utterance The utterance to be judged.
 */
export const applyEntityFilter = (appliedEntityFilters: FiltersItem[], utterance: CluUtteranceSwagger): boolean =>
    !appliedEntityFilters.length ||
    appliedEntityFilters.some(filter => utterance.entities.find(labeledEntity => labeledEntity.category === filter.name));

/**
 * Checks if the utterance has the labeled intent matching with any intent that we filter on.
 *
 * @param appliedIntentFilters The intent filters to be applied.
 * @param utterance The utterance to be judged.
 */
export const applyIntentFilter = (appliedIntentFilters: FiltersItem[], utterance: CluUtteranceSwagger): boolean =>
    !appliedIntentFilters.length || appliedIntentFilters.some(filter => utterance.intent === filter.name);
